import { render, staticRenderFns } from "./AufzugheldenApiView.vue?vue&type=template&id=27c026a4&lang=pug&"
import script from "./AufzugheldenApiView.vue?vue&type=script&lang=ts&"
export * from "./AufzugheldenApiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports